<template>
  <section class="content-section primary">
    <div class="section-title">
      <!--  <div class="section-title-line"></div> -->
      <h1>NATURSTEINTREPPEN</h1>
      <!-- <div class="section-title-line"></div> -->
    </div>
    <div class="container">
      <article class="detailed-info">
        <p>Treppen sind nicht mehr nur eine rein funktionelle und notwendige Verbindung zwischen verschiedenen Wohnebenen. Vielmehr sollen Sie heutzutage neben ihrem praktischen Nutzen auch architektonisch aussehen und perfekt zum restlichen Interieur passen. Aus diesem Grund entscheiden sich immer mehr Menschen für Treppen aus hochwertigem Naturstein.</p>
        <hr>
        <h2>Natursteintreppen: Mehr als nur eine einfache Verbindung zwischen zwei Stockwerken.</h2>
        <p>Jede Natursteinplatte, die zu einer Treppenstufe verarbeitet wird, ist ein echtes Unikat. Durch die natürliche Schönheit und die Exklusivität des Materials sind Natursteine eine echte Investition für die Zukunft. Dabei können Natursteintreppen aus allen erdenklichen Materialien gestaltet werden. Ob Granit, Marmor oder Schiefer: jeder dieser Natursteine verleiht ihrem Haus einen ganz eigenen Charakter und besonderen Flair.
          <br>
          <br>Weitere Vorteile von Natursteintreppen: Das hochwertige Material ist extrem robust, belastbar, pflegeleicht und im Gegensatz zu Holz, das arbeitet und sich im Laufe der Jahre verzieht, bleibt eine Natursteintreppe standfest und ist zudem nicht brennbar.
        </p>
        <hr>
        <div class="image-row">
          <div class="image-row-item">
            <img src="https://marmor-kunze.de/static/portfolio/treppe/treppe01.jpg">
          </div>
          <div class="image-row-item">
            <img src="https://marmor-kunze.de/static/portfolio/treppe/treppe02.jpg">
          </div>
          <div class="image-row-item">
            <img src="https://marmor-kunze.de/static/portfolio/treppe/treppe04.jpg">
          </div>
        </div>
        <hr>
        <h2>Setzen Sie auf individuelle Naturstein-Treppen vom Fachmann in Mönchengladbach!</h2>
        <p>Der Treppenbau ist absolute Millimeterarbeit. Geringe Abweichungen vom Maß können sich je nach Konstruktion von Stufe zu Stufe aufaddieren. Als Naturstein-Experte mit über 50 Jahren Erfahrung haben wir schon so einige Natursteintreppen verbaut und wissen daher, worauf zu achten ist! Welcher Stein für Ihre Natursteintreppe nun Verwendung finden soll, hängt in erster Linie natürlich von Ihrem persönlichen Geschmack und dem bevorzugten Wohnstil ab. Über die physikalischen Eigenschaften der verschiedenen Naturstein-Materialien und auch weitere Faktoren, wie zum Beispiel die Haltbarkeit und Pflege
          <router-link :to="{ name: 'Kontakt' }">informieren und beraten wir Sie gerne</router-link>! So finden wir gemeinsam mit Ihnen einen passenden Naturstein, der Ihrem Geschmack entspricht und sich bestens für ihre Natursteintreppe eignet.
        </p>
      </article>
    </div>
    <hr>
    <div class="image-row">
      <div class="image-row-item">
        <img src="https://marmor-kunze.de/static/portfolio/treppe/treppe06.jpg">
      </div>
      <div class="image-row-item">
        <img src="https://marmor-kunze.de/static/portfolio/treppe/treppe07.jpg">
      </div>
      <div class="image-row-item">
        <img src="https://marmor-kunze.de/static/portfolio/treppe/treppe08.jpg">
      </div>
      <div class="image-row-item">
        <img src="https://marmor-kunze.de/static/portfolio/treppe/IMG_2891_small.jpg">
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "Treppen",
  metaInfo: {
    title: "Natursteintreppen",
    meta: [
      {
        vmid: "description",
        name: "description",
        content:
          "Als Naturstein-Experte mit über 50 Jahren Erfahrung haben wir schon so einige Natursteintreppen verbaut und wissen daher, worauf zu achten ist! "
      },
      {
        vmid: "keywords",
        name: "keywords",
        content:
          "Natursteintreppe, Naturstein Treppe, Granit Treppe, Marmor Treppe, Schiefer Treppe, Granittreppe, Marmortreppe, Schiefertreppe, Natursteintreppe Mönchengladbach, Naturstein Mönchengladbach"
      }
    ],
    links: [
      {
        rel: "canonical",
        href: "https://www.marmor-kunze.de/naturstein-treppen"
      }
    ]
  }
};
</script>
j
<style>
</style>



// WEBPACK FOOTER //
// src/components/views/Treppen.vue